import React, { useEffect, useState } from 'react';
import { reportApi } from '../services/api';
import CompanySearch, { searchableCompanies } from './CompanySearch';

const HeaderCompanySearch = () => {
  const [enabled, setEnabled] = useState(false);
  const [rows, setRows] = useState([]);
  const [directory, setDirectory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    setLoading(true);
    setErrors([]);
    Promise.all([
      reportApi.hub('discover').then((result) => {
        if (active) setRows((result.page || result).sections?.flatMap((section) => section.rows || []) || []);
      }).catch((err) => { if (active) setErrors((current) => [...current, `Covered company search is unavailable: ${err.message}`]); }),
      reportApi.companyDirectory().then((result) => {
        if (active) setDirectory(result.companies);
      }).catch((err) => { if (active) setErrors((current) => [...current, `US-listed company search is unavailable: ${err.message}`]); })
    ]).then(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [enabled]);
  const navigate = (url) => {
    window.history.pushState({}, '', url);
    window.dispatchEvent(new PopStateEvent('popstate'));
    window.dispatchEvent(new HashChangeEvent('hashchange'));
    window.scrollTo(0, 0);
  };
  return <div className="header-company-search" onFocus={() => setEnabled(true)}>
    <CompanySearch companies={searchableCompanies(rows, directory)} id="header-company" label="Quick company search" showSubmit
      statusContent={(loading || errors.length > 0) && <div className="header-search-status">
        {loading && <p role="status">Loading company suggestions...</p>}
        {errors.map((error) => <p role="alert" key={error}>{error}</p>)}
      </div>}
      onSelect={(ticker) => navigate(`/hubs/discover#${encodeURIComponent(ticker)}`)}
      onSearch={(query) => navigate(`/hubs/discover?q=${encodeURIComponent(query)}`)} />
  </div>;
};

export default HeaderCompanySearch;
